import genRequest from "includes/request";
import { useEffect } from "react";

const MONDAY_API_KEY = process.env.REACT_APP_MONDAY_API_KEY;
const MONDAY_BOARD_ID = parseInt(process.env.REACT_APP_MONDAY_BOARD_ID, 10);
const MONDAY_API_URL = "https://api.monday.com/v2";

const useMondayPwaTracker = (account) => {
	useEffect(() => {
		if (!account || !account.AspNetUserId) {
			return;
		}

		let isPWA = false;

		if (localStorage.getItem("MY_ONLYALL_APP_STATUS")) {
			isPWA =
				localStorage.getItem("MY_ONLYALL_APP_STATUS") ===
				"MY_ONLYALL_APP_INSTALLED";
		}

		if (!isPWA) {
			console.log("Lancement non-PWA détecté. Arrêt du tracking.");
			return;
		}

		const trackingKey = `monday_pwa_tracked_${account.AspNetUserId}`;
		if (localStorage.getItem(trackingKey)) {
			return;
		}

		const sendHitToMonday = async () => {
			if (!MONDAY_API_KEY || !MONDAY_BOARD_ID) {
				console.error(
					"Variables d'environnement Monday non configurées."
				);
				return;
			}

			try {
				const siteDetails = await genRequest(`Sites/${account.SiteId}`);

				const variables = {
					boardId: MONDAY_BOARD_ID,
					itemName: `Nouvelle installation PWA - ${
						account.Email || account.AspNetUserId
					}`,
					columnValues: JSON.stringify({
						// On utilise les vrais IDs que vous avez récupérés

						// Colonne "Nom de l'utilisateur"
						text_mkrvz3xw: `${account.FirstName || ""} ${
							account.LastName || ""
						}`,

						// Colonne "Compagnie"
						text_mkrv20v6: account.Company.Name,

						// Colonne "Site" (de type texte)
						text_mkrv6ngv: siteDetails.Name,

						// Colonne "Date d'installation"
						date_mkrvfwm2: {
							date: new Date().toISOString().split("T")[0],
						},
					}),
				};

				const query = `mutation create_item($boardId: ID!, $itemName: String!, $columnValues: JSON!) {
                create_item (board_id: $boardId, item_name: $itemName, column_values: $columnValues) { id }
            }`;

				const mondayData = { query, variables };

				await genRequest(
					MONDAY_API_URL, // url: L'URL directe de l'API Monday
					mondayData, // data: Le corps de notre requête
					"post", // method: 'post'
					{
						// props: L'objet de configuration pour surcharger le comportement
						forceUrl: true, // Pour ignorer l'ajout de API_URL
						headers: {
							// Ceci va écraser le header par défaut grâce à notre modification
							Authorization: MONDAY_API_KEY,
						},
						toast: false, // On ne veut probablement pas de toast pour une tâche de fond
						reportOnFail: false, // Désactive Sentry pour cette requête spécifique si besoin
					}
				);

				localStorage.setItem(trackingKey, "true");
				console.log(
					"Hit PWA envoyé à Monday.com via genRequest avec succès !"
				);
			} catch (error) {
				// L'erreur est déjà loggée par genRequest, mais on peut ajouter un log spécifique si besoin
				console.error(
					"Erreur renvoyée par genRequest lors de l'appel à Monday.com :",
					error
				);
			}
		};

		sendHitToMonday();
	}, [account]);
};

export default useMondayPwaTracker;
